module.exports = __webpack_public_path__ + "static/media/Game-room.e3c5a379.jpg";